import promise from './promise';

export default [promise];
